
import { Separator } from "@/components/ui/separator";
import RightSideMenu from "@/components/navigation/RightSideMenu";
import AdPanel from "@/components/ads/AdPanel";
import SettingsHeader from "@/components/settings/SettingsHeader";
import AppearanceSection from "@/components/settings/AppearanceSection";
import LanguageSection from "@/components/settings/LanguageSection";
import NotificationSection from "@/components/settings/NotificationSection";
import PrivacySection from "@/components/settings/PrivacySection";
import DiscoverySection from "@/components/settings/DiscoverySection";
import SafetySection from "@/components/settings/SafetySection";
import LegalSection from "@/components/settings/LegalSection";
import FavoritesSection from "@/components/settings/FavoritesSection";
import SignOutSection from "@/components/settings/SignOutSection";
import LocationSettings from "@/components/location/LocationSettings";
import DataManagementSection from "@/components/settings/DataManagementSection";
import { useLanguage } from "@/hooks/useLanguage";

const Settings = () => {
  const { isRTL } = useLanguage();

  return (
    <div className={`min-h-screen bg-carbon text-ice-white black-background flex flex-col ${isRTL ? 'rtl' : 'ltr'}`}>
      <AdPanel />
      <RightSideMenu />
      
      <div className="flex-1 max-w-2xl mx-auto p-4 pb-20">
        <SettingsHeader />

        <div className="space-y-6">
          <AppearanceSection />
          <LanguageSection />
          <NotificationSection />
          <LocationSettings />
          <PrivacySection />
          <DiscoverySection />
          <FavoritesSection />
          <DataManagementSection />
          <SafetySection />
          <LegalSection />

          <Separator />

          <SignOutSection />
        </div>
      </div>
    </div>
  );
};

export default Settings;
